// extracted by mini-css-extract-plugin
export default {"bodyGrid":"mainFrame_bodyGrid__MJYPg","borderBox":"mainFrame_borderBox__EmOWR"};